import OpportunitiesDetailsPage from './OpportunitiesDetailsPage';

export default OpportunitiesDetailsPage;
